import {createControlUI, controlUI} from './controlUI';

export class control {
    public constructor(private ui: controlUI) {
        this.ui.onTabClick();
    }
}

export function initControl() {
    const uiInstance = createControlUI();
    const instance = uiInstance.map((uiInstance: controlUI) => {
        return new control(uiInstance);
    });
}
